import { Injectable } from '@angular/core';

import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { CdkPortal } from '@angular/cdk/portal';


 @Injectable({
   providedIn: 'root'
 })
 export class ModalService {

  private overlayRef: OverlayRef;

  constructor(private overlay: Overlay) { }

  open(templateRef: CdkPortal) {
    this.close();

    this.overlayRef = this.overlay.create({
      hasBackdrop: false,
      panelClass: 'ap-stepper-overlay',
      scrollStrategy: this.overlay.scrollStrategies.block(),
      positionStrategy: this.overlay.position().global()
    });

    this.overlayRef.attach(templateRef);
  }

  close(): void {
    if (this.overlayRef != null) {
      if (this.overlayRef.hasAttached()) {
        this.overlayRef.detach();
      }
      this.overlayRef.dispose();
    }
  }
}
